<template>
  <div>
    <i v-show="showStatus('in_process')"
      title="In process" class="fa fa-cog fa-spin fa-fw fa-lg text-warning"></i>

    <i v-show="showStatus('processed')" class="fa fa-check-square-o fa-lg text-success"
      title="Processed" aria-hidden="true"></i>

    <i v-show="showStatus('failed')" class="fa fa-times-circle-o fa-lg text-danger"
      title="Purchase failed" aria-hidden="true"></i>

    <i v-show="showStatus('request_refund')" class="fa fa-undo fa-lg text-warning"
      title="Request refund" aria-hidden="true"></i>

    <i v-show="showStatus('refunded')" class="fa fa-refresh fa-lg text-warning"
      title="Request refund" aria-hidden="true"></i>

    <i v-show="showStatus('failed_refund')" class="fa fa-exclamation-triangle fa-lg text-danger"
      title="Refund failed" aria-hidden="true"></i>
  </div>
</template>

<script>
export default {
  name: 'PurchaseStatusInfo',
  props: {
    status: {
      required: true,
      type: String
    }
  },
  methods: {
    showStatus (statusList) {
      return statusList === this.status
    }
  }
}
</script>
